define(function(){

this["JST"] = this["JST"] || {};

this["JST"]["templates/datalist.html"] = function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<section class="datalist">\n    <ul>\n        ';
 _.each(data.items, function (item) { ;
__p += '\n            <li><button value="' +
((__t = ( item )) == null ? '' : __t) +
'">' +
((__t = ( item )) == null ? '' : __t) +
'</button></li>\n        ';
 }); ;
__p += '\n    </ul>\n</section>';
return __p
};

this["JST"]["templates/feedback-opener.html"] = function(data) {
var __t, __p = '', __e = _.escape;
__p += '<section class="feedback-opener ' +
((__t = ( data.feedbackOpenerCssClass )) == null ? '' : __t) +
'">\n    <button class="link text-action" data-feature-feedback-link data-feature-feedback-key="' +
((__t = ( data.feedbackKey )) == null ? '' : __t) +
'" data-feature-feedback-title="' +
((__t = ( data.feedbackTitle )) == null ? '' : __t) +
'" data-feature-feedback-cssclass="' +
((__t = ( data.feedbackCssClass )) == null ? '' : __t) +
'">' +
((__t = ( data.feedbackLinkText )) == null ? '' : __t) +
'</button>\n</section>';
return __p
};

this["JST"]["templates/filter-add-brand-form.html"] = function(data) {
var __t, __p = '', __e = _.escape;
__p += '<form class="search-result-suggest-brand" data-filter-add-brand-form>\n    <h3>Föreslå varumärke som saknas</h3>\n    <input class="input-text" type="text" name="brandSuggestion" placeholder="apple, volvo, nokia" value="">\n    <button type="submit" class="secondary-action-search">Skicka</button>\n    <span class="message label error">Något gick fel - försök igen!</span>\n    <span class="message label primary">Tack!</span>\n</form>';
return __p
};

this["JST"]["templates/filter-tags-input-template.html"] = function(data) {
var __t, __p = '', __e = _.escape;
__p += '<label class="tag-filter-label">\n    <span class="tag-filter-icon"></span>\n    <input type="text" name="tag-filter" class="input-text tag-filter" placeholder="' +
((__t = ( data.placeholder )) == null ? '' : __t) +
'" data-input-tag-filter>\n</label>\n\n';
return __p
};

this["JST"]["templates/mobile-filter-menu.html"] = function(data) {
var __t, __p = '', __e = _.escape;
__p += '<section class="mobile-filter-menu">\n    <span class="filter-menu-belong-to-arrow"></span>\n    <div class="filter-menu-wrapper">\n        <header>\n            <button class="filter-menu-done" style="float: right;" data-filter-menu-done data-modal-close>\n                Klar\n            </button>\n            <h2 class="filter-menu-headline" data-filter-menu-headline></h2>\n            <a href="' +
((__t = ( data.clearFilterUrl )) == null ? '' : __t) +
'" data-nav class="default-action extra-small-action modal-filter-close"  data-ga-category="Search Filters" data-ga-action="Navigation" data-ga-label="Clear all" data-clear-all-filters>Rensa alla</a>\n        </header>\n    </div>\n</section>';
return __p
};

this["JST"]["templates/native-app-beta-modal.html"] = function(data) {
var __t, __p = '', __e = _.escape;
__p += '<h2 class="native-app-beta-signup-heading">Var med och testa Traderas nya app!</h2>\n<p>\n    Bakom kulisserna har vi arbetat med att bygga två helt nya, snabbare och mer stabila iPhone- och Android-appar.\n    Helt från grunden.Tyck till!\n</p>\n<ul class="native-app-beta-signup-actions">\n    <li class="native-app-beta-signup-action-item"><button class="default-action native-app-action" data-native-beta-no>Nej Tack</button></li>\n    <li class="native-app-beta-signup-action-item"><button class="secondary-action native-app-action" data-native-beta-yes>Läs mer</button></li>\n</ul>';
return __p
};

this["JST"]["templates/recently-viewed-items-list-template.html"] = function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<section class="bp">\n    <div class="row">\n        <div class="col-12 text-center py-3 mt-4">\n            <h2 class="h3 with-asap">Du har nyligen tittat på</h2>\n        </div>\n    </div>\n</section>\n\n<ul class="card-list">\n    ';
 _.each(data.itemList, function (item) { ;
__p += '\n        <li class="item-card">\n            <div class="recent-item-card-body">\n                <a class="recent-item-link" href="' +
((__t = ( item.vipUrl )) == null ? '' : __t) +
'" data-nav data-ga-category="StartPage" data-ga-action="Recently Visited Item clicked"\n                    data-ga-label="' +
((__t = ( item.itemId )) == null ? '' : __t) +
'">\n                    <div>\n                        <figure class="recent-item-figure">\n                            <img src="' +
((__t = ( item.imageUrl )) == null ? '' : __t) +
'" alt="' +
((__t = ( item.altText )) == null ? '' : __t) +
'" title="' +
((__t = ( item.altText )) == null ? '' : __t) +
'" />\n                        </figure>\n                    </div>\n                    <header class="recent-item-header">\n                        <span>\n                            ' +
((__t = ( item.altText )) == null ? '' : __t) +
'\n                        </span>\n                    </header>\n                </a>\n            </div>\n        </li>\n        ';
 }); ;
__p += '\n</ul>';
return __p
};

  return this["JST"];

});


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/templates/templates.js